import {AxiosError} from 'axios'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'
import {get} from 'utils/axios/index'
import {
 ReportConfig,
 ReportsResponse,
 ReportViewParams,
 ReportViewResponse,
 ReportExportData,
 ReportExportResponse,
} from 'models/Reports'
import {toast} from 'react-toastify'
import {IFormField} from 'models/Common'

const getReportsConfigsApi = async (): Promise<{
 data: ReportConfig[] | null
}> => {
 try {
  const res = await get<ReportsResponse>(
   `/reports/configs?is_web_report=true`
  )

  if (res?.success) {
   return {data: res.data}
  }

  return {data: null}
 } catch (err) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return {data: null}
 }
}

const getReportViewApi = async (
 params: ReportViewParams
) => {
 try {
  const query = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
   if (value) {
    query.append(key, String(value))
   }
  })

  const res = await get<ReportViewResponse>(
   `/reports/view?${query.toString()}`
  )

  if (res?.success) {
   return {data: res.data}
  }

  return {data: null}
 } catch (err) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return {data: null}
 }
}

const exportReportApi = async (
 params: IFormField
): Promise<{
 data: ReportExportData | null
}> => {
 try {
  const res = await get<ReportExportResponse>(
   '/reports/export',

   {...params}
  )
  if (res?.success) {
   toast.success(res.message)
   return {data: res.data}
  }
  return {data: null}
 } catch (err) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return {data: null}
 }
}

export {
 exportReportApi,
 getReportViewApi,
 getReportsConfigsApi,
}
